import * as React from 'react';
import { Button, Modal, ModalHeader, ModalBody, CardLink } from 'reactstrap';
import Icon from "components/Varios/Icons.js";
import TooltipItem from "components/Varios/Tooltip.js";

const style = {
    height: 'auto',
    padding: '0px',
};

export default class FileDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = (e) => {
        e.preventDefault();
        let name = e.target.dataset.name;
        let url = e.target.dataset.url;
        
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    }

    renderButton() {
        return (
            <>
                <Button id={this.props.id} style={{ backgroundColor: "#517ED3", height:"27px", width:"27px" }}  className={"m-0 p-1 " } onClick={(e) => this.handleClick(e)} data-name={this.props.name} data-url={this.props.url}>
                <i className="fas fa-download " aria-hidden="true" data-name={this.props.name} data-url={this.props.url}></i>
            </Button>
                <TooltipItem content={"Descargar " + this.props.tipo } id={this.props.id} />
                </>
        );
    }

    render() {
        let contents = this.props.refarchivo

            ? this.renderButton()

            : "";

        if(this.props.noColumnStyle != undefined && this.props.noColumnStyle === true){
            return <div className={"mt-1 ml-2 " + this.props.className} style={{ float: "right" }}>{contents}</div>;
        }
        else {
            return <div className={"col-md-2 col-xs-2 align-self-start " + this.props.className} style={{ float: "right" }}>{contents}</div>;
        }
       

    }

}
